import { useDrawerUntyped } from 'src/modules/drawers';

export const useDrawer = () =>
  useDrawerUntyped<'top' | 'left' | 'gamesSearch' | 'providersSearch'>();
